<!-- Footer -->
<!--
<div style="position: relative;Z-INDEX:-100;margin-top:200px">


        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style="position:absolute;bottom:-200px">
            <path fill="#ab5576" fill-opacity="0.8" d="M0,192L48,192C96,192,192,192,288,202.7C384,213,480,235,576,234.7C672,235,768,213,864,186.7C960,160,1056,128,1152,128C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style="position:absolute;bottom:-200px">
            <path fill="#ab5576" fill-opacity="0.8" d="M0,256L48,229.3C96,203,192,149,288,154.7C384,160,480,224,576,213.3C672,203,768,117,864,112C960,107,1056,181,1152,208C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
    
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style="position:absolute;bottom:-100px">
    <path fill="#ab5576" fill-opacity="0.8" d="M0,192L48,176C96,160,192,128,288,133.3C384,139,480,181,576,197.3C672,213,768,203,864,192C960,181,1056,171,1152,149.3C1248,128,1344,96,1392,80L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
</div>
-->
    <footer class="page-footer font-small background-primary pt-4  ">

    <!-- Footer Links -->
    <div class="container-fluid text-center text-md-left  col-lg-6 col-md-9" style='padding-bottom:50px'>


        <!-- Grid row -->
        <div class="row">
            <!--Grid column-->
            <div class="col-lg-6 col-md-12 mx-auto">
                <h5 class="text-uppercase">Kontakt</h5>

                <p  >
                        <strong>{{text.company.organization}}</strong><br />
                      
                        {{text.address.street}}<br />
                        {{text.address.zip}} {{text.address.city}}
                    </p>
                    <p  >
                        <strong>Telefon:</strong> {{text.address.tel}}<br />
                        <strong *ngIf="text.address.fax.length">Telefax:</strong> {{text.address.fax}}
                    </p>
            </div>
            <!--Grid column-->

            <!--Grid column-->
            <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
                <h5 class="text-uppercase">Verweise</h5>

                <ul class="list-unstyled mb-0">
                    <li>
                        <a routerLink="/impressum">Impressum</a>
                    </li>
                    <li>
                        <a  routerLink="/datenschutz" >Datenschutzerklärung</a>
                    </li>
                    
                </ul>
            </div>

        </div>
              






               
                <!-- Grid row -->

            </div>
            <!-- Copyright -->
            <div class="footer-copyright text-center py-3 unique-color-dark" style="min-height:10vh">© 2026:
                <a href="https://eoipso-jugendhilfe.de/"> eo ipso - Jugendhilfe</a>
            </div>
            <!-- Copyright -->

</footer>
<!-- Footer -->